export interface RuntimeConfig {
  region: string;
  userPoolId: string;
  clientId: string;
  pilot?: boolean;
}

/** Wird beim Deployment aus Pool und gemeinsamem App-Client erzeugt (PlatformWebStack). */
export async function loadConfig(): Promise<RuntimeConfig> {
  if (import.meta.env.VITE_MOCK === 'true') {
    return { region: 'eu-central-1', userPoolId: 'mock', clientId: 'mock' };
  }
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('Konfiguration konnte nicht geladen werden');
  const cfg = (await res.json()) as Partial<RuntimeConfig>;
  for (const key of ['region', 'userPoolId', 'clientId'] as const) {
    if (!cfg[key]) throw new Error(`Konfiguration unvollständig: ${key} fehlt`);
  }
  return cfg as RuntimeConfig;
}
